import { useEffect, useState } from "react";
import { Download, X } from "lucide-react";
import { subscribeInstall, triggerInstall, isStandalone } from "@/lib/pwa";

// Floating "Install app" button shown when the browser offers PWA installation.
export default function InstallPrompt() {
  const [available, setAvailable] = useState(false);
  const [dismissed, setDismissed] = useState(() => {
    try { return localStorage.getItem("penhaus_pwa_dismissed") === "1"; } catch { return false; }
  });

  useEffect(() => subscribeInstall((d) => setAvailable(!!d)), []);

  if (!available || dismissed || isStandalone()) return null;

  const install = async () => { await triggerInstall(); };

  const dismiss = () => {
    setDismissed(true);
    try { localStorage.setItem("penhaus_pwa_dismissed", "1"); } catch { /* ignore */ }
  };

  return (
    <div data-testid="pwa-install-banner"
      className="fixed bottom-4 left-4 z-50 flex items-center gap-3 rounded-full bg-[#0B0E14] text-white pl-4 pr-2 py-2 shadow-2xl border border-white/10">
      <Download className="h-4 w-4 text-[#D4AF37]" />
      <span className="text-sm font-medium">Install PenhausAI</span>
      <button onClick={install} data-testid="pwa-install-btn"
        className="text-sm font-semibold bg-[#D4AF37] text-[#0B0E14] rounded-full px-3 py-1 hover:bg-[#e6c14d] transition-colors">
        Install
      </button>
      <button onClick={dismiss} data-testid="pwa-install-dismiss" className="text-white/50 hover:text-white p-1">
        <X className="h-4 w-4" />
      </button>
    </div>
  );
}
